export default {
    state: {
        loading: false,
        statusOk: null,
        errMessage: "",
        okMessage: "",
        items: [],
        total: 0,
        itemsPerPage: 0,
        page: 1,
    },
    mutations: {
        'ADVANCED_SEARCH_RESULT_LOADING_POSTS' (state, val) {
            state.loading = val;
        },
        'ADVANCED_SEARCH_RESULT_LOADING_MORE' (state, val) {
            state.loadingMore = val;
        },
        'ADVANCED_SEARCH_RESULT_LOADING_POSTS_SUCCESS' (state, val) {
            /*
            state.statusOk = true;
            val.response.forEach(post => {
                let valid = true;
                for(let i=0; i<state.posts.length; i++) {
                    if(state.posts[i]._id === post._id) {
                        valid = false;
                        break;
                    }
                }
                if(valid) state.posts.push(post);
            });
            state.loadMore = val.loadMore;
            state.errMessage = "";
            */

            state.statusOk = true;
            state.total = val.total;
            state.itemsPerPage = val.itemsPerPage;
            state.page = val.page;
            state.items = val.items;
            state.errMessage = "";
        },
        'ADVANCED_SEARCH_RESULT_LOADING_POSTS_ERROR' (state, val) {
            state.statusOk = false;
            state.errMessage = val;
        }
    },
    actions: {
        'ADVANCED_SEARCH_RESULT_FETCH_POSTS' ({commit}, params) {
            /* eslint-disable */
            console.log("params for adv results", params);
            commit('ADVANCED_SEARCH_RESULT_LOADING_POSTS', true);
            //params.query.status = "selling";
            //params.query.sort = "-currentPrice";
            const query = params.query ? ('?'+params.query+'&status=selling&sort=-currentPrice') : '';
            console.log('endpoint', `/item${query}`);
            axios.get(`/item${query}`)
            .then(resp => {
                commit('ADVANCED_SEARCH_RESULT_LOADING_POSTS', false);
                commit('ADVANCED_SEARCH_RESULT_LOADING_POSTS_SUCCESS', resp.data.response);
                console.log("advance search posts", resp);
            })
            .catch(err => {
                commit('ADVANCED_SEARCH_RESULT_LOADING_POSTS', false);
                commit('ADVANCED_SEARCH_RESULT_LOADING_POSTS_ERROR', 'Error. Server error');
                console.log("advance search posts err", err.response);
            });
        }
    }
};